import React, { useState } from 'react';

const locations = [
  'चारबाग रेलवे स्टेशन',
  'आलमबाग बस टर्मिनल/बाज़ार',
  'हजरतगंज',
  'अमीनाबाद/नख़ास',
  'कैसरबाग बस अड्डा',
  'गोमती नगर (विभूति खंड/पत्रकारपुरम)',
  'इंदिरा नगर (पॉलिटेक्निक चौहारा)',
  'अलीगंज (इंजीनियरिंग कॉलेज चौहारा)',
  'आशियाना/तेलीबाग (SGPGI रोड)',
  'लुलु मॉल/शहीद पथ'
];

function PollForm() {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    selectedLocations: [],
    userLocation: null,
    locationAddress: 'Getting location...'
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Automatically get user location when component mounts
  React.useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const lat = position.coords.latitude;
          const lng = position.coords.longitude;
          
          // Get address from coordinates using reverse geocoding
          try {
            const response = await fetch(
              `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}&zoom=18&addressdetails=1`
            );
            const data = await response.json();
            
            const address = data.display_name || `${lat}, ${lng}`;
            
            setFormData(prev => ({
              ...prev,
              userLocation: { lat, lng },
              locationAddress: address
            }));
          } catch (error) {
            console.error('Error getting address:', error);
            setFormData(prev => ({
              ...prev,
              userLocation: { lat, lng },
              locationAddress: `${lat}, ${lng}`
            }));
          }
        },
        (error) => {
          console.error('Error getting location:', error);
          setFormData(prev => ({
            ...prev,
            locationAddress: 'Location not available'
          }));
        }
      );
    } else {
      setFormData(prev => ({
        ...prev,
        locationAddress: 'Location not supported'
      }));
    }
  }, []);

  const styles = {
    container: {
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #f5f5f5 0%, #e8e8e8 100%)',
      padding: '2rem 1rem'
    },
    contentSection: {
      maxWidth: '800px',
      margin: '0 auto'
    },
    heroSection: {
      background: 'white',
      padding: '2rem',
      borderRadius: '15px',
      marginBottom: '2rem',
      boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
      textAlign: 'center'
    },
    mainHeading: {
      fontSize: '2rem',
      color: '#1a1a1a',
      marginBottom: '1rem',
      lineHeight: '1.3',
      fontWeight: '700'
    },
    subHeading: {
      fontSize: '1.5rem',
      color: '#dc2626',
      marginBottom: '1rem',
      fontWeight: '600'
    },
    description: {
      fontSize: '1.1rem',
      color: '#4a4a4a',
      marginBottom: '0.8rem',
      lineHeight: '1.6'
    },
    highlight: {
      fontSize: '1.1rem',
      color: '#16a34a',
      fontWeight: '600',
      marginTop: '1rem'
    },
    form: {
      background: 'white',
      padding: '2rem',
      borderRadius: '15px',
      boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)'
    },
    formSection: {
      marginBottom: '2.5rem'
    },
    sectionTitle: {
      fontSize: '1.3rem',
      color: '#1a1a1a',
      marginBottom: '1.5rem',
      fontWeight: '600',
      borderBottom: '2px solid #dc2626',
      paddingBottom: '0.5rem'
    },
    inputField: {
      width: '100%',
      padding: '1rem',
      fontSize: '1.1rem',
      border: '2px solid #ddd',
      borderRadius: '10px',
      marginBottom: '1rem',
      fontFamily: 'inherit',
      boxSizing: 'border-box'
    },
    locationButton: {
      width: '100%',
      padding: '1rem',
      background: 'linear-gradient(135deg, #16a34a 0%, #15803d 100%)',
      color: 'white',
      border: 'none',
      borderRadius: '10px',
      fontSize: '1.1rem',
      fontWeight: '600',
      cursor: 'pointer',
      fontFamily: 'inherit',
      marginTop: '0.5rem'
    },
    locationsGrid: {
      display: 'grid',
      gridTemplateColumns: '1fr',
      gap: '1rem'
    },
    locationStatus: {
      padding: '0.8rem',
      background: '#e0f2fe',
      color: '#0c4a6e',
      borderRadius: '8px',
      fontSize: '0.95rem',
      marginBottom: '1rem',
      textAlign: 'center',
      border: '1px solid #bae6fd'
    },
    locationCard: (isSelected) => ({
      background: isSelected ? '#dc2626' : '#f9fafb',
      border: `2px solid ${isSelected ? '#dc2626' : '#e5e7eb'}`,
      color: isSelected ? 'white' : '#1a1a1a',
      padding: '1.2rem',
      borderRadius: '12px',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      gap: '1rem',
      fontSize: '1.1rem',
      textAlign: 'left',
      fontFamily: 'inherit',
      fontWeight: isSelected ? '600' : '500'
    }),
    locationIcon: {
      fontSize: '1.5rem',
      width: '30px',
      height: '30px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0
    },
    selectedCount: {
      textAlign: 'center',
      marginTop: '1rem',
      padding: '0.8rem',
      background: '#dcfce7',
      color: '#166534',
      borderRadius: '8px',
      fontWeight: '600',
      fontSize: '1.1rem'
    },
    infoBox: {
      background: 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)',
      padding: '1.5rem',
      borderRadius: '12px',
      border: '2px solid #fbbf24',
      marginBottom: '2rem'
    },
    infoText: {
      margin: '0.5rem 0',
      color: '#78350f',
      fontSize: '1.05rem',
      lineHeight: '1.6'
    },
    submitButton: {
      width: '100%',
      padding: '1.3rem',
      background: 'linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)',
      color: 'white',
      border: 'none',
      borderRadius: '12px',
      fontSize: '1.3rem',
      fontWeight: '700',
      cursor: 'pointer',
      fontFamily: 'inherit',
      boxShadow: '0 4px 15px rgba(220, 38, 38, 0.3)'
    },
    footer: {
      marginTop: '3rem',
      padding: '2rem',
      background: '#1a1a1a',
      borderRadius: '15px',
      textAlign: 'center',
      color: 'white'
    },
    footerText: {
      fontSize: '1.1rem',
      marginBottom: '0.5rem',
      lineHeight: '1.6'
    },
    footerCompany: {
      fontSize: '1.2rem',
      fontWeight: '600',
      color: '#ffffff',
      marginBottom: '0.5rem'
    },
    footerPhone: {
      fontSize: '1.1rem',
      color: '#ffffff',
      fontWeight: '600',
      textDecoration: 'none',
      cursor: 'pointer'
    }
  };

  const handleLocationToggle = (location) => {
    setFormData(prev => {
      const isSelected = prev.selectedLocations.includes(location);
      
      // If clicking to deselect, remove it
      if (isSelected) {
        return {
          ...prev,
          selectedLocations: prev.selectedLocations.filter(loc => loc !== location)
        };
      }
      
      // If already 2 locations selected, show alert and don't add more
      if (prev.selectedLocations.length >= 2) {
        alert('आप अधिकतम 2 जगह ही चुन सकते हैं। पहले किसी को हटाएं।');
        return prev;
      }
      
      // Otherwise, add the location
      return {
        ...prev,
        selectedLocations: [...prev.selectedLocations, location]
      };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.name || !formData.phone || formData.selectedLocations.length === 0) {
      alert('कृपया सभी जानकारी भरें और कम से कम एक जगह चुनें।');
      return;
    }

    if (formData.phone.length !== 10) {
      alert('कृपया सही 10 अंकों का मोबाइल नंबर डालें।');
      return;
    }

    setIsSubmitting(true);

    try {
      const scriptURL = 'https://script.google.com/macros/s/AKfycbypqJzXYuj0SjjhkW-gAfF1uFMDYr1DfBKmvUJ8sPHKB_E4k_uzKUmyDExzrPkd5x2v/exec';
      
      const dataToSend = {
        name: formData.name,
        phone: formData.phone,
        locations: formData.selectedLocations.join(', '),
        locationAddress: formData.locationAddress,
        timestamp: new Date().toLocaleString('hi-IN')
      };

      await fetch(scriptURL, {
        method: 'POST',
        mode: 'no-cors',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(dataToSend)
      });

      alert('धन्यवाद! आपका वोट सफलतापूर्वक रजिस्टर हो गया है! 🎉');
      
      setFormData({
        name: '',
        phone: '',
        selectedLocations: [],
        userLocation: formData.userLocation,
        locationAddress: formData.locationAddress
      });

    } catch (error) {
      console.error('Error:', error);
      alert('कुछ गड़बड़ हो गई। कृपया फिर से कोशिश करें।');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.contentSection}>
        <div style={styles.heroSection}>
          <h1 style={styles.mainHeading}>
            अब EV चार्जिंग की जगह तय करेगी आपकी कम्युनिटी!
          </h1>
          <h2 style={styles.subHeading}>
            बताइए, कहाँ-कहाँ चाहिए EV चार्जर 🔋
          </h2>
          <p style={styles.description}>
            आप अधिकतम <strong style={{color: '#dc2626'}}>2 जगह</strong> चुन सकते हैं जहाँ चार्जर की सबसे ज़्यादा ज़रूरत है।
          </p>
          <p style={styles.highlight}>
            आपका वोट ही EV ड्राइवर्स को सही रास्ता दिखाएगा 🚗⚡
          </p>
        </div>

        <form style={styles.form} onSubmit={handleSubmit}>
          <div style={styles.formSection}>
            <h3 style={styles.sectionTitle}>आपकी जानकारी</h3>
            
            <input
              type="text"
              placeholder="आपका नाम *"
              value={formData.name}
              onChange={(e) => setFormData({...formData, name: e.target.value})}
              style={styles.inputField}
              required
            />

            <input
              type="tel"
              placeholder="मोबाइल नंबर (10 अंक) *"
              value={formData.phone}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, '').slice(0, 10);
                setFormData({...formData, phone: value});
              }}
              style={styles.inputField}
              required
              pattern="[0-9]{10}"
            />
          </div>

          <div style={styles.formSection}>
            <h3 style={styles.sectionTitle}>जगह चुनें (अधिकतम 2)</h3>
            
            <div style={styles.locationsGrid}>
              {locations.map((location, index) => (
                <button
                  key={index}
                  type="button"
                  onClick={() => handleLocationToggle(location)}
                  style={styles.locationCard(formData.selectedLocations.includes(location))}
                >
                  <span style={styles.locationIcon}>
                    {formData.selectedLocations.includes(location) ? '✓' : '○'}
                  </span>
                  <span style={{flex: 1, lineHeight: '1.4'}}>{location}</span>
                </button>
              ))}
            </div>

            {formData.selectedLocations.length > 0 && (
              <div style={styles.selectedCount}>
                {formData.selectedLocations.length} जगह चुनी गई {formData.selectedLocations.length === 2 && '(अधिकतम)'}
              </div>
            )}
          </div>

          <div style={styles.infoBox}>
            <p style={styles.infoText}><strong>👉 ज़्यादा वोट = पहले EV चार्जर वहीं लगेगा</strong></p>
            <p style={styles.infoText}><strong>👉 आपकी राय = सबकी कमाई में बढ़ोतरी</strong></p>
          </div>

          <button 
            type="submit" 
            style={{...styles.submitButton, opacity: isSubmitting ? 0.6 : 1}}
            disabled={isSubmitting}
          >
            {isSubmitting ? 'भेजा जा रहा है...' : 'वोट करें'}
          </button>
        </form>

        <div style={styles.footer}>
          <p style={styles.footerText}>अन्य जानकारी के लिए संपर्क करें</p>
          <p style={styles.footerCompany}>Kazam EV Tech.</p>
          <a href="tel:+918904029996" style={styles.footerPhone}>
            📞 +91 89040 29996
          </a>
        </div>
      </div>
    </div>
  );
}

export default PollForm;